export const resList = [
    {
        info: {
            id: '10583',
            name: 'Pizza Hut',
            cloudinaryImageId:
                'RX_THUMBNAIL/IMAGES/VENDOR/2025/9/1/a46c64e9-675b-45e5-9945-01a30b6cf99b_10583.JPG',
            locality: 'Coles Road',
            areaName: 'Frazer Town',
            costForTwo: '₹350 for two',
            cuisines: ['Pizzas'],
            avgRating: 3.3,
            parentId: '721',
            avgRatingString: '4.3',
            totalRatingsString: '19K+',
            sla: {
                deliveryTime: 32,
                lastMileTravel: 3.7,
                serviceability: 'SERVICEABLE',
                slaString: '30-35 mins',
                lastMileTravelString: '3.7 km',
                iconType: 'ICON_TYPE_EMPTY',
            },
            availability: {
                nextCloseTime: '2025-12-20 03:00:00',
                opened: true,
            },
            badges: {},
            isOpen: true,
            type: 'F',
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {},
                },
            },
            aggregatedDiscountInfoV3: {
                header: '50% OFF',
            },
            differentiatedUi: {
                displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
                differentiatedUiMediaDetails: {
                    lottie: {},
                    video: {},
                },
            },
            reviewsSummary: {},
            displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: '4.4',
                    ratingCount: '2.8K+',
                },
                source: 'GOOGLE',
                sourceIconImageId: 'v1704440323/google_ratings/rating_google_tag',
            },
            ratingsDisplayPreference: 'RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY',
        },
        analytics: {
            context: 'seo-data-aeb28adb-a376-425b-956d-138dc66ff0cc',
        },
        cta: {
            link: 'https://www.swiggy.com/city/bangalore/pizza-hut-coles-road-frazer-town-rest10583',
            type: 'WEBLINK',
        },
    },
    {
        info: {
            id: '770772',
            name: 'Olio - The Wood Fired Pizzeria',
            cloudinaryImageId:
                'RX_THUMBNAIL/IMAGES/VENDOR/2025/12/19/00b17cb8-0b58-4ad5-b115-848bdd9eb1de_770772.JPG',
            locality: 'Ali Askar Road',
            areaName: 'Central Bangalore',
            costForTwo: '₹300 for two',
            cuisines: [
                'Pizzas',
                'Pastas',
                'Italian',
                'Fast Food',
                'Snacks',
                'Beverages',
                'Desserts',
            ],
            avgRating: 4.3,
            parentId: '11633',
            avgRatingString: '4.3',
            totalRatingsString: '1.1K+',
            sla: {
                deliveryTime: 32,
                lastMileTravel: 2,
                serviceability: 'SERVICEABLE',
                slaString: '30-40 mins',
                lastMileTravelString: '2.0 km',
                iconType: 'ICON_TYPE_EMPTY',
            },
            availability: {
                nextCloseTime: '2025-12-20 05:00:00',
                opened: true,
            },
            badges: {
                imageBadges: [
                    {
                        imageId: 'newg.png',
                        description: 'Gourmet',
                    },
                ],
            },
            isOpen: true,
            type: 'F',
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: 'Gourmet',
                                    imageId: 'newg.png',
                                },
                            },
                        ],
                    },
                    textBased: {},
                    textExtendedBadges: {},
                },
            },
            aggregatedDiscountInfoV3: {
                header: '50% OFF',
            },
            differentiatedUi: {
                displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
                differentiatedUiMediaDetails: {
                    lottie: {},
                    video: {},
                },
            },
            reviewsSummary: {},
            displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: '--',
                },
            },
            ratingsDisplayPreference: 'RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY',
        },
        analytics: {
            context: 'seo-data-aeb28adb-a376-425b-956d-138dc66ff0cc',
        },
        cta: {
            link: 'https://www.swiggy.com/city/bangalore/olio-the-wood-fired-pizzeria-ali-askar-road-central-bangalore-rest770772',
            type: 'WEBLINK',
        },
    },
    {
        info: {
            id: '721822',
            name: 'Cheesecake & co.',
            cloudinaryImageId: 'b318c0b4bc2169550145ace1d6e791a2',
            locality: 'rt nagar',
            areaName: 'Koramangala',
            costForTwo: '₹500 for two',
            cuisines: ['Bakery', 'Desserts'],
            avgRating: 4.6,
            veg: true,
            parentId: '387417',
            avgRatingString: '4.6',
            totalRatingsString: '1.3K+',
            sla: {
                deliveryTime: 31,
                lastMileTravel: 5,
                serviceability: 'SERVICEABLE',
                slaString: '30-35 mins',
                lastMileTravelString: '5.0 km',
                iconType: 'ICON_TYPE_EMPTY',
            },
            availability: {
                nextCloseTime: '2025-12-19 23:59:00',
                opened: true,
            },
            badges: {
                imageBadges: [
                    {
                        imageId: 'newg.png',
                        description: 'Gourmet',
                    },
                ],
            },
            isOpen: true,
            type: 'F',
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: 'Gourmet',
                                    imageId: 'newg.png',
                                },
                            },
                        ],
                    },
                    textBased: {},
                    textExtendedBadges: {},
                },
            },
            aggregatedDiscountInfoV3: {
                header: '40% OFF',
                subHeader: 'UPTO ₹80',
            },
            differentiatedUi: {
                displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
                differentiatedUiMediaDetails: {
                    lottie: {},
                    video: {},
                },
            },
            reviewsSummary: {},
            displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: '--',
                },
            },
            ratingsDisplayPreference: 'RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY',
        },
        analytics: {
            context: 'seo-data-aeb28adb-a376-425b-956d-138dc66ff0cc',
        },
        cta: {
            link: 'https://www.swiggy.com/city/bangalore/cheesecake-and-co-rt-nagar-koramangala-rest721822',
            type: 'WEBLINK',
        },
    },
    {
        info: {
            id: '672074',
            name: 'Subway',
            cloudinaryImageId:
                'RX_THUMBNAIL/IMAGES/VENDOR/2025/6/12/8f9a90a5-4f89-4234-b4ed-a840580dbe52_672074.jpg',
            locality: 'Ashok Nagar',
            areaName: 'Sobha Mall',
            costForTwo: '₹350 for two',
            cuisines: ['sandwich', 'Salads', 'wrap', 'Healthy Food'],
            avgRating: 4.4,
            parentId: '2',
            avgRatingString: '4.4',
            totalRatingsString: '2.3K+',
            sla: {
                deliveryTime: 30,
                lastMileTravel: 3.7,
                serviceability: 'SERVICEABLE',
                slaString: '30-35 mins',
                lastMileTravelString: '3.7 km',
                iconType: 'ICON_TYPE_EMPTY',
            },
            availability: {
                nextCloseTime: '2025-12-20 03:00:00',
                opened: true,
            },
            badges: {},
            isOpen: true,
            type: 'F',
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {},
                },
            },
            aggregatedDiscountInfoV3: {
                header: '50% OFF',
            },
            differentiatedUi: {
                displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
                differentiatedUiMediaDetails: {
                    lottie: {},
                    video: {},
                },
            },
            reviewsSummary: {},
            displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: '--',
                },
            },
            ratingsDisplayPreference: 'RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY',
        },
        analytics: {
            context: 'seo-data-aeb28adb-a376-425b-956d-138dc66ff0cc',
        },
        cta: {
            link: 'https://www.swiggy.com/city/bangalore/subway-ashok-nagar-sobha-mall-rest672074',
            type: 'WEBLINK',
        },
    },
    {
        info: {
            id: '755276',
            name: "La Pino'z Pizza",
            cloudinaryImageId: 'f44bc9708c514cd2dd6ae0d8b4677214',
            locality: 'Pulikeshi Nagar',
            areaName: 'Pulikeshi Nagar',
            costForTwo: '₹250 for two',
            cuisines: ['Pizzas', 'Pastas', 'Italian', 'Desserts', 'Beverages'],
            avgRating: 4.3,
            parentId: '4961',
            avgRatingString: '4.3',
            totalRatingsString: '3.5K+',
            sla: {
                deliveryTime: 30,
                lastMileTravel: 3,
                serviceability: 'SERVICEABLE',
                slaString: '30-35 mins',
                lastMileTravelString: '3.0 km',
                iconType: 'ICON_TYPE_EMPTY',
            },
            availability: {
                nextCloseTime: '2025-12-20 02:30:00',
                opened: true,
            },
            badges: {},
            isOpen: true,
            type: 'F',
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {},
                },
            },
            aggregatedDiscountInfoV3: {
                header: 'ITEMS',
                subHeader: 'AT ₹79',
            },
            differentiatedUi: {
                displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
                differentiatedUiMediaDetails: {
                    lottie: {},
                    video: {},
                },
            },
            reviewsSummary: {},
            displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: '4.0',
                    ratingCount: '188',
                },
                source: 'GOOGLE',
                sourceIconImageId: 'v1704440323/google_ratings/rating_google_tag',
            },
            ratingsDisplayPreference: 'RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY',
        },
        analytics: {
            context: 'seo-data-aeb28adb-a376-425b-956d-138dc66ff0cc',
        },
        cta: {
            link: 'https://www.swiggy.com/city/bangalore/la-pinoz-pizza-pulikeshi-nagar-rest755276',
            type: 'WEBLINK',
        },
    },
    {
        info: {
            id: '237668',
            name: "McDonald's",
            cloudinaryImageId:
                'RX_THUMBNAIL/IMAGES/VENDOR/2025/10/3/6e13e84c-0c56-41ac-8096-78ebc5469947_237668.JPG',
            locality: 'Commercial Street',
            areaName: 'Shivajinagar',
            costForTwo: '₹400 for two',
            cuisines: ['Burgers', 'Beverages', 'Cafe', 'Desserts'],
            avgRating: 4.5,
            parentId: '630',
            avgRatingString: '4.5',
            totalRatingsString: '6.9K+',
            sla: {
                deliveryTime: 34,
                lastMileTravel: 3.6,
                serviceability: 'SERVICEABLE',
                slaString: '30-40 mins',
                lastMileTravelString: '3.6 km',
                iconType: 'ICON_TYPE_EMPTY',
            },
            availability: {
                nextCloseTime: '2025-12-19 23:45:00',
                opened: true,
            },
            badges: {
                imageBadges: [
                    {
                        imageId: 'Ratnesh_Badges/Rx_Awards_2025/Bolt.png',
                        description: 'Delivery!',
                    },
                ],
            },
            isOpen: true,
            type: 'F',
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: 'Delivery!',
                                    imageId: 'Ratnesh_Badges/Rx_Awards_2025/Bolt.png',
                                },
                            },
                        ],
                    },
                    textBased: {},
                    textExtendedBadges: {},
                },
            },
            aggregatedDiscountInfoV3: {
                header: 'ITEMS',
                subHeader: 'AT ₹99',
            },
            differentiatedUi: {
                displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
                differentiatedUiMediaDetails: {
                    lottie: {},
                    video: {},
                },
            },
            reviewsSummary: {},
            displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: '--',
                },
            },
            ratingsDisplayPreference: 'RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY',
        },
        analytics: {
            context: 'seo-data-aeb28adb-a376-425b-956d-138dc66ff0cc',
        },
        cta: {
            link: 'https://www.swiggy.com/city/bangalore/mcdonalds-commercial-street-shivajinagar-rest237668',
            type: 'WEBLINK',
        },
    },
    {
        info: {
            id: '3369',
            name: 'Truffles',
            cloudinaryImageId: 'cd832b6167eb9f88aeb1ccdebf38d942',
            locality: 'St. Marks Road',
            areaName: 'St. Marks Road',
            costForTwo: '₹450 for two',
            cuisines: ['American', 'Desserts', 'Continental', 'Italian'],
            avgRating: 4.6,
            parentId: '218065',
            avgRatingString: '4.6',
            totalRatingsString: '148K+',
            sla: {
                deliveryTime: 33,
                lastMileTravel: 4.5,
                serviceability: 'SERVICEABLE',
                slaString: '30-35 mins',
                lastMileTravelString: '4.5 km',
                iconType: 'ICON_TYPE_EMPTY',
            },
            availability: {
                nextCloseTime: '2025-12-20 00:00:00',
                opened: true,
            },
            badges: {
                imageBadges: [
                    {
                        imageId: 'Rxawards/_CATEGORY-Burger.png',
                        description: 'Delivery!',
                    },
                ],
            },
            isOpen: true,
            type: 'F',
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: 'Delivery!',
                                    imageId: 'Rxawards/_CATEGORY-Burger.png',
                                },
                            },
                        ],
                    },
                    textBased: {},
                    textExtendedBadges: {},
                },
            },
            aggregatedDiscountInfoV3: {
                header: '₹125 OFF',
                subHeader: 'ABOVE ₹249',
                discountTag: 'FLAT DEAL',
            },
            differentiatedUi: {
                displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
                differentiatedUiMediaDetails: {
                    lottie: {},
                    video: {},
                },
            },
            reviewsSummary: {},
            displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: '4.5',
                    ratingCount: '20K+',
                },
                source: 'GOOGLE',
                sourceIconImageId: 'v1704440323/google_ratings/rating_google_tag',
            },
            ratingsDisplayPreference: 'RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY',
        },
        analytics: {
            context: 'seo-data-aeb28adb-a376-425b-956d-138dc66ff0cc',
        },
        cta: {
            link: 'https://www.swiggy.com/city/bangalore/truffles-st-marks-road-rest3369',
            type: 'WEBLINK',
        },
    },
    {
        info: {
            id: '696230',
            name: 'ITC Master Chef Creations',
            cloudinaryImageId:
                'RX_THUMBNAIL/IMAGES/VENDOR/2025/9/6/14baf724-99f4-4733-aa96-6d300bf2036d_696230.JPG',
            locality: 'Shivaji Nagar',
            areaName: 'Dispensary Rd',
            costForTwo: '₹650 for two',
            cuisines: ['North Indian', 'Biryani', 'Kebabs', 'rolls', 'Desserts'],
            avgRating: 4.6,
            parentId: '11992',
            avgRatingString: '4.6',
            totalRatingsString: '1.5K+',
            sla: {
                deliveryTime: 36,
                lastMileTravel: 4.4,
                serviceability: 'SERVICEABLE',
                slaString: '35-40 mins',
                lastMileTravelString: '4.4 km',
                iconType: 'ICON_TYPE_EMPTY',
            },
            availability: {
                nextCloseTime: '2025-12-20 02:00:00',
                opened: true,
            },
            badges: {
                imageBadges: [
                    {
                        imageId: 'newg.png',
                        description: 'Gourmet',
                    },
                ],
            },
            isOpen: true,
            type: 'F',
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: 'Gourmet',
                                    imageId: 'newg.png',
                                },
                            },
                        ],
                    },
                    textBased: {},
                    textExtendedBadges: {},
                },
            },
            aggregatedDiscountInfoV3: {
                header: 'ITEMS',
                subHeader: 'AT ₹249',
            },
            differentiatedUi: {
                displayType: 'ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT',
                differentiatedUiMediaDetails: {
                    lottie: {},
                    video: {},
                },
            },
            reviewsSummary: {},
            displayType: 'RESTAURANT_DISPLAY_TYPE_DEFAULT',
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: '--',
                },
            },
            ratingsDisplayPreference: 'RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY',
        },
        analytics: {
            context: 'seo-data-aeb28adb-a376-425b-956d-138dc66ff0cc',
        },
        cta: {
            link: 'https://www.swiggy.com/city/bangalore/itc-master-chef-creations-shivaji-nagar-dispensary-rd-rest696230',
            type: 'WEBLINK',
        },
    },
];

export const MOCK_MENU = [
    {
        title: 'Recommended',
        itemCards: [
            {
                card: {
                    info: {
                        id: '1',
                        name: 'Paneer Butter Masala',
                        price: 250,
                        description: 'Creamy and rich North Indian curry with soft paneer cubes.',
                        isVeg: true,
                        rating: 4.5,
                        imageId:
                            'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
            {
                card: {
                    info: {
                        id: '2',
                        name: 'Chicken Biryani',
                        price: 320,
                        description:
                            'Fragrant basmati rice cooked with tender chicken pieces and aromatic spices.',
                        isVeg: false,
                        rating: 4.7,
                        imageId:
                            'https://images.unsplash.com/photo-1589302168068-964664d93dc0?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
        ],
    },
    {
        title: 'Main Course',
        itemCards: [
            {
                card: {
                    info: {
                        id: '3',
                        name: 'Butter Chicken',
                        price: 280,
                        description: 'Tender chicken in a rich, creamy tomato-based gravy.',
                        isVeg: false,
                        rating: 4.6,
                        imageId:
                            'https://images.unsplash.com/photo-1588166524941-3bf61a9c41db?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
            {
                card: {
                    info: {
                        id: '4',
                        name: 'Dal Makhani',
                        price: 180,
                        description: 'Slow-cooked black lentils in butter and cream.',
                        isVeg: true,
                        rating: 4.4,
                        imageId:
                            'https://images.unsplash.com/photo-1546833999-b9f5816029bd?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
            {
                card: {
                    info: {
                        id: '5',
                        name: 'Kadai Paneer',
                        price: 240,
                        description: 'Cottage cheese cooked with bell peppers in a spicy gravy.',
                        isVeg: true,
                        rating: 4.3,
                        imageId:
                            'https://images.unsplash.com/photo-1565557623262-b51c2513a641?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
        ],
    },
    {
        title: 'Thalis',
        itemCards: [
            {
                card: {
                    info: {
                        id: '6',
                        name: 'Veg Thali',
                        price: 180,
                        description: 'A wholesome meal with roti, rice, dal, sabzi, and dessert.',
                        isVeg: true,
                        rating: 4.5,
                        imageId:
                            'https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
            {
                card: {
                    info: {
                        id: '7',
                        name: 'Non-Veg Thali',
                        price: 250,
                        description:
                            'Complete meal with chicken curry, rice, roti, dal, and salad.',
                        isVeg: false,
                        rating: 4.6,
                        imageId:
                            'https://media.istockphoto.com/id/1158623408/photo/indian-hindu-veg-thali-food-platter-selective-focus.jpg?s=612x612&w=0&k=20&c=6h4hX6H6i4f5i5j5kl5m5n5o5p5q5r5s5t5',
                    },
                },
            },
        ],
    },
    {
        title: 'Breads',
        itemCards: [
            {
                card: {
                    info: {
                        id: '8',
                        name: 'Butter Naan',
                        price: 50,
                        description: 'Soft and fluffy naan brushed with butter.',
                        isVeg: true,
                        rating: 4.4,
                        imageId:
                            'https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
            {
                card: {
                    info: {
                        id: '9',
                        name: 'Garlic Naan',
                        price: 60,
                        description: 'Naan topped with fresh garlic and coriander.',
                        isVeg: true,
                        rating: 4.5,
                        imageId:
                            'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
            {
                card: {
                    info: {
                        id: '10',
                        name: 'Tandoori Roti',
                        price: 30,
                        description: 'Whole wheat bread baked in tandoor.',
                        isVeg: true,
                        rating: 4.3,
                        imageId:
                            'https://images.unsplash.com/photo-1626082896492-766af4eb6501?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
        ],
    },
    {
        title: 'Desserts',
        itemCards: [
            {
                card: {
                    info: {
                        id: '11',
                        name: 'Gulab Jamun',
                        price: 80,
                        description: 'Soft milk dumplings soaked in sugar syrup.',
                        isVeg: true,
                        rating: 4.6,
                        imageId:
                            'https://images.unsplash.com/photo-1589119908634-b13d23e9e346?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
            {
                card: {
                    info: {
                        id: '12',
                        name: 'Rasmalai',
                        price: 100,
                        description: 'Soft paneer patties in creamy, sweetened milk.',
                        isVeg: true,
                        rating: 4.7,
                        imageId:
                            'https://images.unsplash.com/photo-1576618148400-f54bed99fcfd?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60',
                    },
                },
            },
        ],
    },
];
